import { HealthResponse } from '@aeris/contracts';
import { request } from "./client.js";
/** A saúde agregada da API — `/health`, fora do `/api/v1`. */
/**
 * Fetches aggregate health.
 *
 * `/health` rather than `/health/ready` on purpose: the aggregate answers 200
 * with a `degraded` body when the database is down, which lets the shell tell
 * "API up, database down" apart from "nothing reachable". A 503 from the
 * readiness probe cannot express that difference.
 */
export const fetchHealth = async (signal) => HealthResponse.parse(await request('/health', { signal }));
//# sourceMappingURL=health.js.map